import IframeTemplate from "../layout/content-templates/iframe/IframeTemplate.tsx";
import { useIntl } from "react-intl";
import { useParams } from "react-router";
import useCheckoutLinks from "../../../common/features/checkout/useCheckoutLinks.ts";

export default function OrderHistory() {
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Order History" });
  const { makeCheckoutUrl } = useCheckoutLinks();
  const params = useParams();

  return (
    <IframeTemplate title={title}>
      <iframe
        title={title}
        src={makeCheckoutUrl(
          `/order-history${params.orderId ? `/${params.orderId}` : ""}`
        )}
      />
    </IframeTemplate>
  );
}
